import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IKaspersky } from '../models/models'

export class GetKasperskyProductsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'product/GetKasperskyProducts',
      requesterInfo,
    })
  }

  public async getKasperskyProducts(): Promise<IKaspersky> {
    return await this.getAsync<IKaspersky>()
  }
}
